import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-page-not-found",
  imports: [CommonModule],
  templateUrl: "./page-not-found.component.html",
  styleUrl: "./page-not-found.component.scss",
})
export class PageNotFoundComponent {}
